module.exports = __webpack_public_path__ + "static/media/target4_0.0976ca9c.png";